import { Table } from '@tanstack/react-table';

import { usePopoverState } from '@work4all/data/lib/hooks/usePopoverState';

import { PopoverV8 } from './popover/PopoverV8';

export interface SortColumnPopoverV8Props {
  table: Table<unknown>;
  popoverState: ReturnType<typeof usePopoverState>;
}

export function SortColumnPopoverV8(props: SortColumnPopoverV8Props) {
  const { table, popoverState } = props;

  return <PopoverV8 popoverState={popoverState} table={table} />;
}
